import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";
import { FormInput } from "lucide-react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ITPrintData = () => {
  const route = useParams().id;
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("userName");
  const [ITCData, setITCData] = useState(null);

  useEffect(() => {
    const getITCData = async () => {
      const response = await fetch(`${api_url}/api/users/get-itc-data`, {
        method: "POST",
        body: JSON.stringify({
          userId,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      if (result.status === 201) {
        let data = result.users.find((item) => item._id === route);
        setITCData(data);
      }
    };
    getITCData();
  }, []);

  const [dMonthValues, setDMonthValues] = useState(null);
  const [calculatedValues, setCalculatedValues] = useState(null);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [oldRegimeData, setOldRegimeData] = useState(null);
  const [newRegimeData, setNewRegimeData] = useState(null);

  useEffect(() => {
    // setEmployeeDetails(() => JSON.parse(ITCData.employeeDetails));
    // setDMonthValues(() => JSON.parse(ITCData.monthValues));
    // setCalculatedValues(() => JSON.parse(ITCData.calculatedValues));
    // setOldRegimeData(() => JSON.parse(ITCData.oldRegimeData));
    // setNewRegimeData(() => JSON.parse(ITCData.newRegimeData));

    try {
      if (ITCData?.employeeDetails) {
        setEmployeeDetails(JSON.parse(ITCData.employeeDetails));
      }
      if (ITCData?.monthValues) {
        setDMonthValues(JSON.parse(ITCData.monthValues));
      }
      if (ITCData?.calculatedValues) {
        setCalculatedValues(JSON.parse(ITCData.calculatedValues));
      }
      if (ITCData?.oldRegimeData) {
        setOldRegimeData(JSON.parse(ITCData.oldRegimeData));
      }
      if (ITCData?.newRegimeData) {
        setNewRegimeData(JSON.parse(ITCData.newRegimeData));
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
    }
  }, [ITCData]);

  const months = [
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Other",
  ];

  const columns = [
    "Basic",
    "DA",
    "HRA",
    "TA",
    "Fix TA",
    "WA",
    "CLA",
    "NPS",
    "Basic Arrs",
    "DA Arrs",
    "Total Pay",
    "GPF",
    "GPF Inst",
    "NPS",
    "DCPS",
    "PT",
    "GIS",
    "LIC",
    "I.Tax",
  ];

  const [monthValues, setMonthValues] = useState(
    months.reduce((acc, month) => {
      acc[month] = columns.reduce((colAcc, col) => {
        colAcc[col] = 0;
        return colAcc;
      }, {});
      return acc;
    }, {})
  );

  const [selectedMonths, setSelectedMonths] = useState(
    months.reduce((acc, month) => {
      acc[month] = false;
      return acc;
    }, {})
  );

  const FormSection = ({ title, children }) => (
    <div
      className={`bg-white border-gray-700 border-1 py-2 px-2   rounded-lg mb-3 `}
    >
      <h5 className="font-bold mb-3">{title}</h5>
      {children}
    </div>
  );

  const handleCalculatedValueChange = (field, value) => {
    // setCalculatedValues((prev) => {
    //   const updatedValues = { ...prev, [field]: parseFloat(value) || 0 };
    //   updatedValues.totalIncome =
    //     updatedValues.grossSalary + updatedValues.otherIncome;
    //   updatedValues.totalDeduction80C =
    //     updatedValues.gpf +
    //     updatedValues.gpfinst +
    //     updatedValues.dcps +
    //     updatedValues.gis +
    //     updatedValues.lic +
    //     updatedValues.tutionFees +
    //     updatedValues.nsc +
    //     updatedValues.pli +
    //     updatedValues.Rd +
    //     updatedValues.homeLoanPrincipal +
    //     updatedValues.mutualFund;
    //   updatedValues.totalDeductionVIA =
    //     updatedValues.ccd1b +
    //     updatedValues.ccd2 +
    //     updatedValues.mediclaim +
    //     updatedValues.dependentHandicapped +
    //     updatedValues.educationLoanInterest +
    //     updatedValues.electricVehicleLoan +
    //     updatedValues.donation +
    //     updatedValues.selfHandicapped;
    //   return updatedValues;
    // });
  };

  const FormInput = React.memo(
    ({ label, value, onChange, readOnly, disabled }) => {
      return (
        <div className="flex justify-between items-center mb-1">
          <label
            className={
              label === "Total Income" ||
              label === "Old Regime Tax" ||
              label === "New Regime Tax" ||
              label === "Tax Deducted From SALARY Rs." ||
              label === "Net Income Tax to Pay Rs." ||
              label === "Total Income Tax PAYABLE Rs."
                ? "fw-bold text-basic"
                : label === "Deduction U/s 80-C" ||
                  label === "Total Deduction U/S VI-A"
                ? "fw-bold text-sm"
                : "fw-bold text-sm"
            }
          >
            {label}{" "}
            {label === "Deduction U/s 80-C" ? (
              <small className="text-danger fw-bold">
                (limit upto 1.5 lacs)
              </small>
            ) : (
              ""
            )}
          </label>
          <label
            className={
              label === "Total Income"
                ? "fw-bold  px-2 text-right"
                : label === "Old Regime Tax" ||
                  label === "New Regime Tax" ||
                  label === "Tax Deducted From SALARY Rs." ||
                  label === "Net Income Tax to Pay Rs." ||
                  label === "Deduction U/s 80-C" ||
                  label === "Total Deduction U/S VI-A" ||
                  label === "Total Income Tax PAYABLE Rs."
                ? "fw-bold  px-2 text-right"
                : " fw-bold px-2 text-right"
            }
          >
            {value}
          </label>
        </div>
      );
    }
  );

  function getZoomLevel() {
    return window.devicePixelRatio || 1;
  }

  // const generateEditablePDF = () => {
  //   const input = document.getElementById("mainDiv"); // The div you want to convert into a PDF

  //   const pdf = new jsPDF("a4"); // 'a4' for page size (portrait by default)

  //   // Define margin size (10px) on all sides
  //   const margin = 10;

  //   // Ensure the content fits within the A4 page size
  //   const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin; // Adjust width for margin
  //   const pdfHeight = pdf.internal.pageSize.getHeight() - 2 * margin; // Adjust height for margin

  //   const contentHeight = input.offsetHeight;
  //   const contentWidth = input.offsetWidth;

  //   // Calculate scaling factor dynamically based on both width and height constraints
  //   const scaleFactorWidth = pdfWidth / contentWidth;
  //   const scaleFactorHeight = pdfHeight / contentHeight;

  //   // Choose the smaller scale factor to ensure the content fits within the page
  //   const scaleFactor = Math.min(scaleFactorWidth, scaleFactorHeight);

  //   // Calculate the X and Y positions to center the content, leaving the margin
  //   const scaledWidth = contentWidth * scaleFactor;
  //   const scaledHeight = contentHeight * scaleFactor;

  //   const centerX = (pdfWidth - scaledWidth) / 2 + margin;
  //   const centerY = (pdfHeight - scaledHeight) / 2;

  //   // Use the html method to directly add the HTML content to the PDF
  //   pdf.html(input, {
  //     callback: (pdf) => {
  //       // Save the generated PDF as a single page
  //       pdf.save(`${employeeDetails.EmpName}.pdf`);
  //     },
  //     x: centerX, // Center the content horizontally, considering the margin
  //     y: centerY, // Center the content vertically, considering the margin
  //     html2canvas: {
  //       scale: scaleFactor, // Scale the content to fit on one page
  //     },
  //   });
  // };

  const generateEditablePDF = () => {
    const input = document.getElementById("mainDiv"); // The div you want to convert into a PDF

    const pdf = new jsPDF("a4"); // 'a4' for page size (portrait by default)

    // Define margin size (10px) on all sides
    const margin = 10;

    // Ensure the content fits within the A4 page size
    const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin; // Adjust width for margin
    const pdfHeight = pdf.internal.pageSize.getHeight() - 2 * margin; // Adjust height for margin

    const contentHeight = input.offsetHeight;
    const contentWidth = input.offsetWidth;

    // Calculate scaling factor dynamically based on both width and height constraints
    const scaleFactorWidth = pdfWidth / contentWidth;
    const scaleFactorHeight = pdfHeight / contentHeight;

    // Choose the smaller scale factor to ensure the content fits within the page
    const scaleFactor = Math.min(scaleFactorWidth, scaleFactorHeight);

    // Calculate the scaled width and height
    const scaledWidth = contentWidth * scaleFactor;
    const scaledHeight = contentHeight * scaleFactor;

    // Use the html method to directly add the HTML content to the PDF
    pdf.html(input, {
      callback: (pdf) => {
        // Save the generated PDF as a single page
        pdf.save(`${employeeDetails.EmpName}.pdf`);
      },
      x: (pdfWidth - scaledWidth) / 2 + margin, // Center horizontally, considering the margin
      y: margin, // Start from the top margin
      html2canvas: {
        scale: scaleFactor, // Scale the content to fit on one page
      },
    });
  };

  const exportToExcel = () => {
    if (!employeeDetails) {
      alert("No employee details available.");
      return;
    }

    // ✅ 1. **Employee Basic Details**
    const employeeData = [
      ["Field", "Value"],
      ["Office Name", employeeDetails.officeName || "-"],
      ["Office Address", employeeDetails.officeAddress || "-"],
      ["Full Name", employeeDetails.EmpName || "-"],
      ["Designation", employeeDetails.EmpDesignation || "-"],
      ["Gender", employeeDetails.gender || "-"],
      ["Pay Scale", employeeDetails.payScale || "-"],
      ["Financial Year", employeeDetails.financialYear || "-"],
      ["PAN No.", employeeDetails.PANNo || "-"],
      ["Birth Date", employeeDetails.dateOfBirth || "-"],
      ["Aadhar No.", employeeDetails.adharNo || "-"],
      ["TAN No.", employeeDetails.officerTANNo || "-"],
    ];

    // Table Data - Columns
    const tableColumns = ["Month", ...columns];

    // Table Data - Rows
    const tableData = months.map((month) => [
      month,
      ...columns.map((col) =>
        dMonthValues ? getColumnValue(month, col) : "0"
      ),
    ]);

    // Calculate Total Row
    const totalRow = [
      "Total",
      ...calculateTotals().map((total) => Math.round(total)),
    ];

    // ✅ 2. **Income & Deductions**
    const incomeDeductionsData = [
      ["Category", "Amount"],
      ["Gross Salary", calculatedValues?.grossSalary || 0],
      ["Other Income", calculatedValues?.otherIncome || 0],
      ["Total Income", calculatedValues?.totalIncome || 0],
      ["Old Regime Standard Deduction", 50000],
      ["New Regime Standard Deduction", 75000],
      ["P.TAX", calculatedValues?.ptax || 0],
      ["Home Loan Interest", calculatedValues?.homeLoanInterest || 0],
      ["HRA Exemption", calculatedValues?.hraExemption || 0],
    ];

    // ✅ 3. **Deductions U/S 80-C**
    const deductions80CData = [
      ["Category", "Amount"],
      ["GPF", calculatedValues?.gpf || 0],
      ["DCPS", calculatedValues?.dcps || 0],
      ["GIS", calculatedValues?.gis || 0],
      ["LIC", calculatedValues?.lic || 0],
      ["Tuition Fees", calculatedValues?.tutionFees || 0],
      ["NSC", calculatedValues?.nsc || 0],
      ["PLI/RD", calculatedValues?.pliRd || 0],
      ["Home Loan Principal", calculatedValues?.homeLoanPrincipal || 0],
      ["Mutual Fund", calculatedValues?.mutualFund || 0],
      ["Total Deduction U/S 80-C", calculatedValues?.totalDeduction80C || 0],
    ];

    // ✅ 4. **Deductions U/S VI-A**
    const deductionsVIAData = [
      ["Category", "Amount"],
      ["CCD 1B (NPS)", calculatedValues?.ccd1b || 0],
      ["CCD 2 Employer NPS", calculatedValues?.nps || 0],
      ["Mediclaim Insurance", calculatedValues?.mediclaim || 0],
      [
        "Dependent Handicapped Person",
        calculatedValues?.dependentHandicapped || 0,
      ],
      ["Education Loan Interest", calculatedValues?.educationLoanInterest || 0],
      ["Electric Vehicle Loan", calculatedValues?.electricVehicleLoan || 0],
      ["Donation", calculatedValues?.donation || 0],
      ["Self Handicapped Person", calculatedValues?.selfHandicapped || 0],
      ["Total Deduction U/S VI-A", calculatedValues?.totalDeductionVIA || 0],
    ];

    // ✅ 5. **Old Regime Tax Details**
    const oldRegimeTaxData = [
      ["Category", "Amount"],
      ["Old Taxable Income", oldRegimeData?.old_regime_taxable_income || 0],
      ["Old Tax", oldRegimeData?.old_regime_tax || 0],
      ["Rebate Under Section 87A", oldRegimeData?.rebate || 0],
      ["Education Cess @ 4%", oldRegimeData?.education_cess || 0],
      ["Total IT Payable", oldRegimeData?.total_it_payable || 0],
      ["Tax Deducted from Salary", oldRegimeData?.deducted_salary || 0],
      ["Net Income Tax Pay", oldRegimeData?.net_it_pay || 0],
    ];

    // ✅ 6. **New Regime Tax Details**
    const newRegimeTaxData = [
      ["Category", "Amount"],
      ["New Taxable Income", newRegimeData?.new_regime_taxable_income || 0],
      ["New Tax", newRegimeData?.new_regime_tax || 0],
      ["Rebate Under Section 87A", newRegimeData?.rebate || 0],
      ["Education Cess @ 4%", newRegimeData?.education_cess || 0],
      ["Total IT Payable", newRegimeData?.total_it_payable || 0],
      ["Tax Deducted from Salary", newRegimeData?.deducted_salary || 0],
      ["Net Income Tax Pay", newRegimeData?.net_it_pay || 0],
    ];

    // ✅ 7. **Final Payable Tax**
    const totalPayableTax = [
      [
        "Total Income Tax Payable",
        Math.min(
          oldRegimeData?.total_it_payable || 0,
          newRegimeData?.total_it_payable || 0
        ),
      ],
      ["Financial Year", employeeDetails?.financialYear || "-"],
    ];

    // ✅ 8. **Certification Details**
    const certificationData = [
      ["Certified By", "Signature", "Designation"],
      [employeeDetails?.EmpName, "", employeeDetails?.EmpDesignation],
      [
        employeeDetails?.officerDDOName,
        "",
        employeeDetails?.officerDDODesignation,
      ],
    ];

    // 🔹 **Combine all sections into one Excel sheet**
    const sheetData = [
      ["Employee Details"],
      ...employeeData,
      [],
      tableColumns,
      ...tableData,
      totalRow,
      [],
      ["Income & Deductions"],
      ...incomeDeductionsData,
      [],
      ["Deductions U/S 80-C"],
      ...deductions80CData,
      [],
      ["Deductions U/S VI-A"],
      ...deductionsVIAData,
      [],
      ["Old Regime Tax Details"],
      ...oldRegimeTaxData,
      [],
      ["New Regime Tax Details"],
      ...newRegimeTaxData,
      [],
      ["Total Payable Tax"],
      ...totalPayableTax,
      [],
      ["Certification"],
      ...certificationData,
    ];

    // Create worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Employee Report");

    // Save the file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "Employee_Payroll_Report.xlsx");
  };

  // const exportToExcel = () => {
  //   // Define the employee details in an array format
  //   const employeeData = [
  //     ["Office Name", employeeDetails?.officeName || "-"],
  //     ["Office Address", employeeDetails?.officeAddress || "-"],
  //     ["Full Name", employeeDetails?.EmpName || "-"],
  //     ["Designation", employeeDetails?.EmpDesignation || "-"],
  //     ["Gender", employeeDetails?.gender || "-"],
  //     ["Pay Scale", employeeDetails?.payScale || "-"],
  //     ["Financial Year", employeeDetails?.financialYear || "-"],
  //     ["PAN No.", employeeDetails?.PANNo || "-"],
  //     ["Birth Date", employeeDetails?.dateOfBirth || "-"],
  //     ["Aadhar No.", employeeDetails?.adharNo || "-"],
  //     ["TAN No.", employeeDetails?.officerTANNo || "-"],
  //   ];

  //   // Table Data - Columns
  //   const tableColumns = ["Month", ...columns];

  //   // Table Data - Rows
  //   const tableData = months.map((month) => [
  //     month,
  //     ...columns.map((col) =>
  //       dMonthValues ? getColumnValue(month, col) : "0"
  //     ),
  //   ]);

  //   // Calculate Total Row
  //   const totalRow = [
  //     "Total",
  //     ...calculateTotals().map((total) => Math.round(total)),
  //   ];

  //   // Combine Everything
  //   const sheetData = [
  //     ...employeeData,
  //     [],
  //     tableColumns,
  //     ...tableData,
  //     totalRow,
  //   ];

  //   // Create worksheet and workbook
  //   const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Employee Data");

  //   // Save the file
  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });
  //   const data = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });
  //   saveAs(data, "Employee_Payroll_Report.xlsx");
  // };

  const calculateTotals = () => {
    return columns.map((column) =>
      months.reduce((total, month) => {
        // // Handle special column cases
        if (column === "Basic Arrs") {
          const value =
            parseFloat(dMonthValues && dMonthValues[month]?.["BasicArrs"]) || 0; // Default to 0 (number)
          return total + value;
        } else if (column === "DA Arrs") {
          const value =
            parseFloat(dMonthValues && dMonthValues[month]?.["DAArrs"]) || 0; // Default to 0 (number)
          return total + value;
        } else if (column === "Total Pay") {
          const value =
            parseFloat(dMonthValues && dMonthValues[month]?.["TotalPay"]) || 0; // Default to 0 (number)
          return total + value;
        } else if (column === "GPF Inst") {
          const value =
            parseFloat(dMonthValues && dMonthValues[month]?.["GPFInst"]) || 0; // Default to 0 (number)
          return total + value;
        } else {
          const value =
            parseFloat(dMonthValues && dMonthValues[month]?.[column]) || 0;
          return total + value;
        }
      }, 0)
    );
  };

  const getColumnValue = (month, column) => {
    // alert(column);
    // Check if the column name is one of the special columns
    if (column === "Basic Arrs") {
      return dMonthValues[month]?.["BasicArrs"] || "0"; // Default to "0" if value is not available
    }
    if (column === "DA Arrs") {
      return dMonthValues[month]?.["DAArrs"] || "0"; // Default to "0" if value is not available
    }
    if (column === "Total Pay") {
      return dMonthValues[month]?.["TotalPay"] || "0"; // Default to "0" if value is not available
    }

    if (column === "GPF Inst") {
      return dMonthValues[month]?.["GPFInst"] || "0"; // Default to "0" if value is not available
    }

    // Check if the column exists in the dMonthValues for the given month
    if (dMonthValues && dMonthValues[month]?.[column] !== undefined) {
      return dMonthValues[month][column];
    }

    // Default to "0" if no value is found
    return "0";
  };

  return (
    <div className="pb-5">
      <div
        className="mainDiv IT-table text-left"
        id="mainDiv"
        style={{
          width: "100%",
          marginTop: "10px",
          fontSize: 18,
        }}
      >
        <div style={{ paddingLeft: "50px", paddingRight: "10px" }}>
          <div className="card pb-2">
            <div className="row">
              <div className="col-lg-12">
                <h3
                  className="fw-bold text-center text-xxl"
                  style={{ fontSize: 22 }}
                >
                  {employeeDetails && employeeDetails.officeName},(
                  {employeeDetails && employeeDetails.officeAddress})
                </h3>
              </div>
            </div>
          </div>
          <div className="card px-3 mt-2">
            <div className="row">
              <div className="col-lg-5">
                <div className="row my-2">
                  <div className="col-lg-5">
                    <p>
                      <strong>Full Name :</strong>
                    </p>
                    <p>
                      <strong>Designation :</strong>
                    </p>
                    <p>
                      <strong>Gender :</strong>
                    </p>
                    <p>
                      <strong>Pay Scale :</strong>
                    </p>
                  </div>
                  <div className="col-lg-7">
                    <p>
                      <strong>
                        {employeeDetails && employeeDetails.EmpName}
                      </strong>
                    </p>
                    <p>
                      <span>
                        {employeeDetails && employeeDetails.EmpDesignation}
                      </span>
                    </p>
                    <p>
                      <span>{employeeDetails && employeeDetails.gender}</span>
                    </p>
                    <p>
                      <span>{employeeDetails && employeeDetails.payScale}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="row my-2">
                  <div className="col-lg-5">
                    <p>
                      <strong>Financial Year :</strong>
                    </p>
                    <p>
                      <strong> PAN No. :</strong>
                    </p>
                    <p>
                      <strong>Birth Date :</strong>
                    </p>
                    <p>
                      <strong>Aadhar No. :</strong>
                    </p>
                  </div>
                  <div className="col-lg-7">
                    <p className="">
                      <span>
                        {(employeeDetails && employeeDetails.financialYear) ||
                          "-"}
                      </span>
                    </p>
                    <p className="">
                      <span>
                        {(employeeDetails && employeeDetails.PANNo) || "-"}
                      </span>
                    </p>
                    <p className="">
                      <span>
                        {(employeeDetails && employeeDetails.dateOfBirth) ||
                          "-"}
                      </span>
                    </p>
                    <p className="">
                      <span>
                        {(employeeDetails && employeeDetails.adharNo) || "-"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-lg-8 ps-0">
              <div className="card py-2 my-2">
                <h5 className="fw-bold text-center mb-0">
                  Monthly Statement Showing Pay & Allowences And Deduction
                  Details
                </h5>
              </div>
            </div>
            <div className="col-lg-4 pe-0">
              <div className="card px-1 py-2 my-2">
                <h5 className="fw-bold d-flex justify-between text-capitalize mb-0">
                  TAN No. : {employeeDetails && employeeDetails.officerTANNo}
                </h5>
              </div>
            </div>
          </div>

          <div className="overflow-x-auto ">
            <div className="min-w-[1000px]">
              <table className="w-100 border-collapse pt-0 mt-0">
                <thead>
                  <tr>
                    <th className="text-center pt-0 mt-0 sticky left-0 z-10 border border-gray-300 bg-gray-100 px-1">
                      Month
                    </th>
                    {columns.map((column, index) => (
                      <th
                        key={index}
                        className="text-center pt-0 mt-0 border border-gray-300 bg-gray-100 px-1"
                      >
                        {column}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {months.map((month, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className={rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="fw-bold text-center pt-0 mt-0  sticky z-10 border border-gray-300 px-1 text-blue-500 bg-inherit">
                        <label className="text-center pt-0 mt-0 items-center space-x-2">
                          {month === "July" ? (
                            <span className="text-danger fw-bold">{month}</span>
                          ) : (
                            <span>{month}</span>
                          )}
                        </label>
                      </td>
                      {columns.map((column, colIndex) => (
                        <td
                          key={colIndex}
                          className="fw-bold text-center  border border-gray-300 px-1 pt-0 mt-0"
                        >
                          <label
                            type="text"
                            className={
                              column === "TotalPay"
                                ? "fw-bold text-purple-800 pt-0 mt-0 w-full bg-transparent outline-none text-center focus:ring-2 focus:ring-blue-300 rounded"
                                : column === "Basic"
                                ? "fw-bold pt-0 mt-0 w-full bg-transparent outline-none text-center focus:ring-2 focus:ring-blue-300 rounded"
                                : "w-full pt-0 mt-0 bg-transparent outline-none text-center focus:ring-2 focus:ring-blue-300 rounded"
                            }
                          >
                            {dMonthValues && getColumnValue(month, column)}
                            {/* {dMonthValues &&
                            dMonthValues[month]?.[column] !== undefined
                              ? dMonthValues && dMonthValues[month][column]
                              : "0"} */}
                          </label>
                        </td>
                      ))}
                    </tr>
                  ))}
                  <tr className=" bg-gray-100">
                    <td className="fw-bold sticky text-center z-10 border border-gray-300 px-1 pt-0 mt-0 text-black bg-gray-100">
                      Total
                    </td>
                    {calculateTotals().map((total, index) => (
                      <td
                        key={index}
                        className="fw-bold border border-gray-300 px-1 pt-0 mt-0 text-black text-center"
                      >
                        {Math.round(total)}{" "}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="max-w-8xl mx-auto  py-3">
            <div className="row">
              <div className="col-lg-4 px-0">
                <FormSection title="Income">
                  <FormInput
                    label="Gross Salary"
                    value={calculatedValues && calculatedValues.grossSalary}
                    readOnly
                  />
                  <FormInput
                    label="Other Income"
                    value={
                      Math.round(
                        calculatedValues && calculatedValues.otherIncome * 100
                      ) / 100
                    }
                    readOnly={false}
                  />

                  <FormInput
                    label="Total Income"
                    value={
                      Math.round(
                        calculatedValues && calculatedValues.totalIncome * 100
                      ) / 100
                    }
                    readOnly
                  />
                  <div className="mt-2">
                    <h5 className="font-semibold mb-2">Deduction</h5>
                    <FormInput
                      label="Old Regime Standard Deduction"
                      value={50000}
                      readOnly
                    />
                    <FormInput
                      label="New Regime Standard Deduction"
                      value={75000}
                      readOnly
                    />
                    <FormInput
                      label="P.TAX"
                      value={
                        Math.round(
                          calculatedValues && calculatedValues.ptax * 100
                        ) / 100
                      }
                      readOnly
                    />
                  </div>
                  <div className="mt-2">
                    <h5 className="font-semibold mb-2">Home Loan</h5>
                    <FormInput
                      label="Home Loan Interest"
                      value={
                        Math.round(
                          calculatedValues &&
                            calculatedValues.homeLoanInterest * 100
                        ) / 100
                      }
                      readOnly={false}
                    />
                    <FormInput
                      label="Home Loan Interest (Eligible)"
                      value={Math.round(
                        200000 <
                          parseInt(
                            calculatedValues &&
                              calculatedValues.homeLoanInterest
                          )
                          ? parseInt(200000)
                          : parseInt(
                              calculatedValues &&
                                calculatedValues.homeLoanInterest
                            )
                      )}
                      readOnly={false}
                    />
                  </div>
                  <div className="mt-2">
                    <h5 className="font-semibold mb-2">HRA Rent</h5>
                    <FormInput
                      label="HRA Exemption"
                      value={
                        Math.round(
                          calculatedValues &&
                            calculatedValues.hraExemption * 100
                        ) / 100
                      }
                      readOnly={false}
                    />
                  </div>
                </FormSection>
              </div>
              <div className="col-lg-4">
                <FormSection title="Deduction U/S 80-C">
                  <FormInput
                    label="GPF"
                    value={Math.round(
                      parseInt(calculatedValues && calculatedValues.gpf) +
                        parseInt(calculatedValues && calculatedValues.gpfinst)
                    )}
                    readOnly
                  />
                  <FormInput
                    label="DCPS"
                    value={calculatedValues && calculatedValues.dcps}
                    readOnly
                  />
                  <FormInput
                    label="GIS"
                    value={calculatedValues && calculatedValues.gis}
                    readOnly
                  />
                  <FormInput
                    label="LIC"
                    value={calculatedValues && calculatedValues.lic}
                    readOnly
                  />
                  <FormInput
                    label="Tution Fees"
                    value={calculatedValues && calculatedValues.tutionFees}
                    onChange={(value) =>
                      handleCalculatedValueChange("tutionFees", value)
                    }
                    readOnly={false}
                  />
                  <FormInput
                    label="NSC"
                    value={calculatedValues && calculatedValues.nsc}
                    readOnly={false}
                  />
                  <FormInput
                    label="PLI/RD"
                    value={calculatedValues && calculatedValues.pliRd}
                    readOnly={false}
                  />
                  <FormInput
                    label="Home Loan Principal"
                    value={
                      calculatedValues && calculatedValues.homeLoanPrincipal
                    }
                    readOnly={false}
                  />
                  <FormInput
                    label="Mutual Fund"
                    value={calculatedValues && calculatedValues.mutualFund}
                    readOnly={false}
                  />
                  <FormInput
                    label="Total Deduction U/s 80-C"
                    value={
                      calculatedValues && calculatedValues.totalDeduction80C
                    }
                    readOnly
                  />
                  <FormInput
                    label={`Deduction U/s 80-C`}
                    value={
                      calculatedValues &&
                      calculatedValues.totalDeduction80C > 150000
                        ? 150000
                        : calculatedValues && calculatedValues.totalDeduction80C
                    }
                    readOnly
                  />
                </FormSection>
              </div>
              <div className="col-lg-4 px-0">
                <FormSection title="Deduction U/S VI-A">
                  <FormInput
                    label="CCD 1B Additional Deducton to NPS"
                    value={calculatedValues && calculatedValues.ccd1b}
                    readOnly={false}
                  />
                  <FormInput
                    label="CCD 2 Employer contribution (NPS)"
                    value={calculatedValues && calculatedValues.nps}
                    readOnly
                  />
                  <FormInput
                    label="U/S 80D Mediclaim Insurance"
                    value={calculatedValues && calculatedValues.mediclaim}
                    readOnly={false}
                  />
                  <FormInput
                    label="U/S 80DD Dependent Handicapped Person"
                    value={
                      calculatedValues && calculatedValues.dependentHandicapped
                    }
                    readOnly={false}
                  />
                  <FormInput
                    label="U/S 80E Interest on educational loan"
                    value={
                      calculatedValues && calculatedValues.educationLoanInterest
                    }
                    readOnly={false}
                  />
                  <FormInput
                    label="U/S 80EEB Electric Vehicle Loan"
                    value={
                      Math.round(
                        calculatedValues &&
                          calculatedValues.electricVehicleLoan * 100
                      ) / 100
                    }
                    readOnly={false}
                  />
                  <FormInput
                    label="U/S 80G Donation"
                    value={
                      Math.round(
                        calculatedValues && calculatedValues.donation * 100
                      ) / 100
                    }
                    readOnly={false}
                  />
                  <FormInput
                    label="U/S 80U Self Handicapped Person"
                    value={
                      Math.round(
                        calculatedValues &&
                          calculatedValues.selfHandicapped * 100
                      ) / 100
                    }
                    readOnly={false}
                  />
                  <FormInput
                    label="Total Deduction U/S VI-A"
                    value={
                      Math.round(
                        calculatedValues &&
                          calculatedValues.totalDeductionVIA * 100
                      ) / 100
                    }
                    readOnly
                  />
                </FormSection>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <FormSection title="Old Regime">
                <FormInput
                  label={`Old Taxable Income`}
                  value={
                    oldRegimeData && oldRegimeData.old_regime_taxable_income
                  }
                  readOnly
                />
                <FormInput
                  label={`Old Tax`}
                  value={oldRegimeData && oldRegimeData.old_regime_tax}
                  readOnly
                />
                <FormInput
                  label="Rebate Under Section 87A"
                  value={oldRegimeData && oldRegimeData.rebate}
                  readOnly
                />
                <FormInput
                  label="Education Cess @ 4%"
                  value={oldRegimeData && oldRegimeData.education_cess}
                  readOnly
                />
                <FormInput
                  label="Total Income Tax PAYABLE Rs."
                  value={oldRegimeData && oldRegimeData.total_it_payable}
                  readOnly
                />
                <FormInput
                  label="Tax Deducted From SALARY Rs."
                  value={oldRegimeData && oldRegimeData.deducted_salary}
                  readOnly
                />
                <FormInput
                  label="Net Income Tax to Pay Rs."
                  value={oldRegimeData && oldRegimeData.net_it_pay}
                  readOnly
                />
              </FormSection>
              <FormSection title="New Regime">
                <FormInput
                  label={`New Taxable Income`}
                  value={
                    newRegimeData && newRegimeData.new_regime_taxable_income
                  }
                  readOnly
                />
                <FormInput
                  label={`New Tax`}
                  value={newRegimeData && newRegimeData.new_regime_tax}
                  readOnly
                />
                <FormInput
                  label="Rebate Under Section 87A"
                  value={newRegimeData && newRegimeData.rebate}
                  readOnly
                />
                <FormInput
                  label="Education Cess @ 4%"
                  value={newRegimeData && newRegimeData.education_cess}
                  readOnly
                />
                <FormInput
                  label="Total Income Tax PAYABLE Rs."
                  value={newRegimeData && newRegimeData.total_it_payable}
                  readOnly
                />
                <FormInput
                  label="Tax Deducted From SALARY Rs."
                  value={newRegimeData && newRegimeData.deducted_salary}
                  readOnly
                />
                <FormInput
                  label="Net Income Tax to Pay Rs."
                  value={newRegimeData && newRegimeData.net_it_pay}
                  readOnly
                />
              </FormSection>
              <div className=" mt-1">
                <div className="card p-3">
                  <div className="row">
                    <div className="col-lg-7">
                      <h5 className="fw-bold">I have Accepted </h5>
                    </div>
                    <div className="col-lg-5">
                      <p className="fw-bold text-end text-danger">
                        {oldRegimeData?.total_it_payable <
                        newRegimeData?.total_it_payable
                          ? "Old Regime"
                          : "New Regime"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="card p-3 mt-3">
                  <div className="row">
                    <div className="col-lg-9">
                      <h5 className="fw-bold">Total Income Tax to Pay</h5>
                    </div>
                    <div className="col-lg-3">
                      <p className="fw-bold text-end text-danger">
                        {Math.min(
                          oldRegimeData && oldRegimeData.total_it_payable,
                          newRegimeData && newRegimeData.total_it_payable
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="card p-3 mt-3">
                  <div className="row">
                    <div className="col-lg-8">
                      <h5 className="fw-bold">For the Financial Year</h5>
                    </div>
                    <div className="col-lg-4">
                      <p className="fw-bold text-end text-danger">
                        {employeeDetails && employeeDetails.financialYear}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6 ps-0">
                <div className="card p-3 h-100">
                  <h5 className="fw-bold text-center mb-3">
                    I Certify That information given by me is true & Correct for
                    the Fin. Yr.{" "}
                    {employeeDetails && employeeDetails.financialYear}
                  </h5>
                  <div className="row align-items-center">
                    <div className="col-lg-4">
                      <h5 className="fw-bold">Signature</h5>
                    </div>
                    <div className="col-lg-8">
                      <textarea
                        className="form-control bg-white"
                        readOnly
                        rows={3}
                      ></textarea>
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-lg-4">
                      <p className="fw-bold">Name : </p>
                      <p className="fw-bold">Designation : </p>
                    </div>
                    <div className="col-lg-8">
                      <p className="fw-bold">
                        {employeeDetails && employeeDetails.EmpName}
                      </p>
                      <p className="fw-bold">
                        {employeeDetails && employeeDetails.EmpDesignation}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 pe-0">
                <div className="card p-3 h-100">
                  <h5 className="fw-bold text-center mb-3">
                    The above given information found correct, <br />
                    Hence it is certified.
                  </h5>
                  <div className="row align-items-center">
                    <div className="col-lg-4">
                      <h5 className="fw-bold">Signature</h5>
                    </div>
                    <div className="col-lg-8">
                      <textarea
                        className="form-control bg-white"
                        readOnly
                        rows={3}
                      ></textarea>
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-lg-4">
                      <p className="fw-bold">Name : </p>
                      <p className="fw-bold">Designation : </p>
                      <p className="fw-bold">Office Name : </p>
                    </div>
                    <div className="col-lg-8">
                      <p className="fw-bold">
                        {employeeDetails && employeeDetails.officerDDOName}
                      </p>
                      <p className="fw-bold">
                        {employeeDetails &&
                          employeeDetails.officerDDODesignation}
                      </p>
                      <p className="fw-bold">
                        {employeeDetails && employeeDetails.officeName}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Sub Section Ends */}
      <div className="mt-3">
        <div className="row">
          <div className="col-lg-3 m-auto text-center ">
            <button
              onClick={() => generateEditablePDF()}
              className="bg-blue-500 w-100 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              Print
            </button>
          </div>
          <div className="col-lg-3 m-auto text-center ">
            <button
              onClick={() => exportToExcel()}
              className="bg-blue-500 w-100 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              Excel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ITPrintData;
